import {forwardRef} from 'react';
import {join} from '../../utils';
import {Selectors} from '../button.selectors';
import Button from '../button/button';
import {ButtonProps} from '../types';

import styles from './outlined.module.less';

export const Outlined = forwardRef<HTMLButtonElement, ButtonProps>(
	({className, ...props}, ref) =>
		<Button data-cy={Selectors.Outlined}
		        {...props}
		        ref={ref}
		        className={join(styles.outlined, className)}/>
);

export default Outlined;
